module.exports = __webpack_public_path__ + "c931c571046093eb7514d41d614f4ce7.svg";